import { LegacyIIQApi } from '../legacy-iiq-api';

export const getRoleUsers =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  ({ id, ...params }: { id: string; params?: Record<string, any> }) =>
    api.get(`/roles/${id}/users`, params).then((res) => res.data);
